import { createAction, props } from '@ngrx/store';
import { ProjectCardViewModel } from 'src/app/roles/_shared-by-role/project-dashboard/models/project-card.model';
import {
  AttentionItemSettingViewModel,
  IPIMSDomain,
  ProjectPhaseViewModel,
  ProjectValueRecognitionViewModel,
  ProjectViewModel,
  SMEDisciplineViewModel,
} from 'src/app/shared/models/autogenerated';

export const setAllProjects = createAction(
  '[Project] Projects Loaded Success',
  props<{ projects: ProjectViewModel[] | null; currentUserId: string }>()
);

export const loadAllProjects = createAction('[Project] Load Projects');

export const loadCurrentProject = createAction(
  '[Project] Load Current Project'
);

export const loadEditProjectById = createAction(
  '[Project] Load Edit Project by Id',
  props<{ projectId: string }>()
);

export const setCurrentProject = createAction(
  '[Project] Load Current Project Success',
  props<{ project: ProjectViewModel | null }>()
);

export const setEditProjectForm = createAction(
  '[Project] set Edit Project Form',
  props<{ project: ProjectViewModel | null }>()
);

export const updateProject = createAction('[Project] Update Project');

export const updateProjectSuccess = createAction(
  '[Project] Update Project Success',
  props<{ project: ProjectViewModel | null }>()
);

export const archiveProject = createAction(
  '[Project] Archive Project',
  props<{ projectId: string }>()
);

export const reinstateArchivedProject = createAction(
  '[Project] Reinstate Archive Project',
  props<{ projectId: string }>()
);

export const deleteProject = createAction(
  '[Project] Delete Project',
  props<{ project: ProjectViewModel }>()
);

export const invalidateCurrentProject = createAction(
  '[Project] Invalidate Project'
);

export const updateCurrentProjectPhase = createAction(
  '[ProjectPhase] Update ProjectPhase'
);

export const updateCurrentProjectPhaseSuccess = createAction(
  '[ProjectPhase] Update ProjectPhase Success',
  props<{ project: ProjectPhaseViewModel | null }>()
);

export const loadCurrentPhase = createAction('[Project] Load Current Phase');

export const setCurrentPhase = createAction(
  '[Project] Load Current Phase Success',
  props<{ phase: ProjectPhaseViewModel | undefined }>()
);

export const invalidateCurrentPhase = createAction(
  '[Project] Invalidate Current Phase'
);

export const loadDisciplinesForCurrentPhase = createAction(
  '[Project] Load Disciplines For Current Phase'
);

export const setDisciplinesForCurrentPhase = createAction(
  '[Project] Load Disciplines For Current Phase Success',
  props<{ disciplines: SMEDisciplineViewModel[] | undefined }>()
);

export const setStatusForCurrentPhase = createAction(
  '[Project] Set Status For Current Phase',
  props<{ status: string }>()
);

export const downloadTOR = createAction('[Project] Download TOR');

export const exportDeliverableRequestToProject = createAction(
  '[ProjectPhase] Export Deliverable Request to Project'
);

export const clearProjectForm = createAction(
  '[EditProjectForm] Clear project form'
);

export const updateProjectType = createAction(
  '[EditProjectForm] Update Project Type',
  props<{ onShore: boolean; offShore: boolean }>()
);

export const clearPhaseFormUnsavedChanges = createAction(
  '[EditPhaseForm] Clear changes'
);

export const setProjectPageView = createAction(
  '[Project] Set page view',
  props<{ projectPageView: string }>()
);

export const loadIPIMSDomains = createAction('[IPIMS DA] Load Domains');

export const loadIPIMSDomainsSuccess = createAction(
  '[IPIMS DA] Load Domains Success',
  props<{ domains: IPIMSDomain[] }>()
);

export const loadProjectValueRecognition = createAction(
  '[Project] Load Project Value Recognition'
);

export const setProjectValueRecognition = createAction(
  '[Project] Set Project Value Recognition',
  props<{
    projectValueRecognition: ProjectValueRecognitionViewModel[];
  }>()
);

export const updateValueRecognitionNotes = createAction(
  '[ProjectPhase] Update Value Recognition Notes',
  props<{
    notes: string;
  }>()
);

export const setValueRecognitionNotes = createAction(
  '[ProjectPhase] Set Value Recognition Notes',
  props<{
    notes: string;
  }>()
);

export const loadHasUserGlobalAdminAccess = createAction(
  '[Project] Load User Global Admin Access'
);

export const setHasUserGlobalAdminAccess = createAction(
  '[Project] Set User Global Admin Access',
  props<{
    hasUserGlobalAdminAccess: boolean;
  }>()
);

export const projectsListQuickFilterChange = createAction(
  '[ProjectPhase] Projects Quick Filter Changed',
  props<{ quickFilterText: string }>()
);

export const projectsListQuickFilterChangeSuccess = createAction(
  '[ProjectPhase] Projects Quick Filter Change Success',
  props<{ quickFilterText: string }>()
);

export const setProjectsFiltered = createAction(
  '[Project] Set projects filtered to display',
  props<{
    projectsFiltered: ProjectCardViewModel[] | null;
  }>()
);

export const loadAttentionItemSettingsProjectById = createAction(
  '[Project] Load Attention Item Settings Project by Id',
  props<{ projectId: string }>()
);

export const setAttentionItemSettings = createAction(
  '[Project] Set Attention Item Settings to display',
  props<{
    attentionItemSetting: AttentionItemSettingViewModel | null;
  }>()
);

export const updateAttentionItemSetting = createAction('[Project] Update Attention Item Setting',
  props<{
    attentionItemSetting: AttentionItemSettingViewModel;
  }>()
);

export const updateAttentionItemSettingSuccess = createAction(
  '[Project] Update Attention Item Setting Success',
  props<{ attentionItemSetting: AttentionItemSettingViewModel | null }>()
);